// extracted by mini-css-extract-plugin
module.exports = {"option":"snippet-option_option__3N6EH","disabled":"snippet-option_disabled__3Cnnl","details":"snippet-option_details__1tcEa","fade-in":"snippet-option_fade-in__3xAL9"};